import CacheItem from "@core/api/request/CacheItem";

export default new class Cache {
    items = {};

    authenticationFailed() {
        Object.keys(this.items).forEach(key => {
            delete this.items[key];
        });
    }

    item(name, requestor) {
        if (!this.items.hasOwnProperty(name)) {
            this.items[name] = new CacheItem(requestor);
        }

        return this.items[name];
    }

    invalidate(name) {
        if (this.items.hasOwnProperty(name)) {
            delete this.items[name];
        }
    }
};
